import * as React from 'react';
import { CalendarIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';

export function DatePicker({
  value,
  onChange,
  buttonProps = {},
  calendarProps = {},
}: {
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  buttonProps?: React.ComponentProps<typeof Button>;
  calendarProps?: React.ComponentProps<typeof Calendar>;
}) {
  const [open, setOpen] = React.useState(false);
  const { className: buttonClassName, ...restButtonProps } = buttonProps;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          id="date"
          className={cn(
            'tw:w-48 tw:justify-between tw:font-normal',
            buttonClassName,
          )}
          {...restButtonProps}
        >
          {value
            ? value.toLocaleDateString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })
            : 'Select date'}
          <CalendarIcon className="tw:text-muted-foreground tw:size-4 tw:shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="tw:w-auto tw:overflow-hidden tw:p-0"
        align="start"
      >
        <Calendar
          {...calendarProps}
          mode="single"
          captionLayout="dropdown"
          defaultMonth={value}
          selected={value}
          onSelect={(date) => {
            onChange(date);
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
